'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Switch = require('./Switch');

var _Switch2 = _interopRequireDefault(_Switch);

var _ButtonSwitch = require('./ButtonSwitch');

var _ButtonSwitch2 = _interopRequireDefault(_ButtonSwitch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

_Switch2["default"].ButtonSwitch = _ButtonSwitch2["default"];
exports["default"] = _Switch2["default"];
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./components/switch/index.jsx
 ** module id = 235
 ** module chunks = 0
 **/